import React, { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { cn } from '../../lib/utils';
import KvkkConsentGate from '../KvkkConsentGate';
import ForcePasswordChangeGate from '../ForcePasswordChangeGate';

export const DashboardLayout = ({ children, title, subtitle }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Tablet: auto-collapse sidebar
  useEffect(() => {
    const checkWidth = () => {
      const w = window.innerWidth;
      if (w < 1024) {
        setSidebarCollapsed(true);
      }
    };
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [children]);

  return (
    <div className="min-h-screen bg-[#F7F9FC]">
      {/* Sidebar - hidden on mobile, icon-only on tablet, full on desktop */}
      <div className={cn(
        'hidden md:block',
        mobileMenuOpen && 'block'
      )}>
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
      </div>

      {/* Mobile sidebar overlay */}
      {mobileMenuOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-30 md:hidden"
            onClick={() => setMobileMenuOpen(false)}
          />
          <div className="fixed left-0 top-0 h-full z-40 md:hidden">
            <Sidebar collapsed={false} onToggle={() => setMobileMenuOpen(false)} />
          </div>
        </>
      )}

      {/* Main Content */}
      <div
        className={cn(
          'transition-all duration-300',
          // Mobile: no margin (sidebar hidden)
          // Tablet (md): sidebar icon-only = 64px
          // Desktop (lg): sidebar collapsed=64px, expanded=256px
          sidebarCollapsed
            ? 'md:ml-16'
            : 'md:ml-16 lg:ml-64'
        )}
      >
        <Topbar
          title={title}
          subtitle={subtitle}
          onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        />
        <main className="p-4 md:p-6 lg:p-8">{children}</main>
      </div>

      {/* KVKK in-app consent gate (only renders for doctors/clinic_admins who haven't consented) */}
      <KvkkConsentGate />
      {/* Force password change gate — shown after KVKK is satisfied */}
      <ForcePasswordChangeGate />
    </div>
  );
};
